import React, { Component } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';

const meta = {
	description: 'State of Origin 2021 is nearly upon us!',
	image: '/images/blog2021stateoforigin2021/stateoforigin2021.png',
	title: 'State of Origin 2021: Who will bring it home? | blueshyft',
	url: 'https://blueshyft.com.au/blogs/stateoforigin2021',
};

import '../../css/about.css';

export default class About extends Component {
	render () {

		return (
			<React.Fragment>
				<Helmet
					title={meta.title}
					meta={[
						{ name: 'description', content: meta.description },
						{ property: 'og:title', content: meta.title },
						{ property: 'og:url', content: meta.url },
						{ property: 'og:site_name', content: 'Blueshyft' },
						{ property: 'og:type', content: 'website' },
						{ property: 'og:image', content: meta.image },
						{ property: 'og:description', content: meta.description },
						{ property: 'twitter:card', content: 'summary_large_image' },
						{ property: 'twitter:site', content: '@Blueshyft' },
						{ property: 'twitter:title', content: meta.title },
						{ property: 'twitter:description', content: meta.description },
						{ property: 'twitter:image', content: meta.image },
					]}
				/>

				<section className="about-cryptocurrency">
					<div className="about-cryptocurrency-sub">
						<div className="about-cryptocurrency-image-container">
							<img src="/images/blog2021stateoforigin2021/stateoforigin2021.png" alt="crpyotcurrency" className="about-cryptocurrency-image" />
						</div>
					</div>
				</section>

				<section className="wrapup">
					<div className="block block-crypto">
						<p>State of Origin 2021 is nearly upon us! The first game will return to the Country Bank Stadium, with Suncorp Stadium and Stadium Australia hosting the second and third games. The dates for the games are June 9, June 27, and finishing on July 14.</p>
					</div>

					<div className="block block-crypto">
						<h4>Players to watch</h4>
						<p>In terms of team selection, the NSW team does not include any major surprises apart from Jake Trbojevic’s number 10 role. For Manly, Jake plays as a loose forward, however Brad Fittler believes that Jake’s playmaking capabilities can be used effectively in the front row. It will be interesting to see whether this cunning positional change will pay off in a team that is dominated by youthful players.</p>
						<p>For Queensland, key players such as Cameron Munster and Harry Grant were doubtful due to injury, but they are set to return for Game 1. On paper, the Queensland team looks a lot weaker than the Penrith-dominated Blues side. This was also the case in last year’s series and the result was very different to what everyone expected. Don’t rule them out just yet.</p>
					</div>

					<div className="block block-crypto">
						<h4>A game of halves</h4>
						<p>Queensland proved all pundits and punters wrong last year by defeating NSW 2-1, winning the series in the final game. NSW have an excellent team, having two of the most dominant halves in recent rugby league history: Nathan Cleary and Jarome Luai. This season, the pair have dominated the NRL, each contributing massively to Penrith’s unbeaten run this campaign. Nevertheless, the technically-gifted Daly Cherry-Evans and player of the series last year, Cameron Munster, cannot be discounted. It goes without saying that the battle between the halves could be the deciding factor in whoever wins the series.</p>
						<p>Many of the bookmakers are tipping NSW to win the series, even with the recent announcement that the first game will be held in Townsville as opposed to Melbourne. Generous odds are on the line, coupled with numerous promotions run by Ladbrokes, so make sure you head down to your nearest blueshyft-enabled store to deposit funds into your wagering account!</p>
					</div>
				</section>

			</React.Fragment>
		);
	}
};



// WEBPACK FOOTER //
// ./client/scenes/blog-20210604/index.js